import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const KoachProfile: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // 프로필 메인 페이지 접근 시 기본 정보로 리다이렉트
        navigate('/koach/profile/basic', { replace: true });
    }, [navigate]);

    return null;
};

export default KoachProfile;

